/**
 * @desc 获取ebs汇率集合
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.EbsRateResponse>>;
export function request(
  params: API.basics.exchangeRateFacadeImpl.getEbsRateListByDate.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/rpc/basics/getEbsRateListByDate`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
